import React from 'react'


function Title({ short, content }) {
  return(
    <h2 short={short}>{content}</h2>
  )
}

export default Title
